import * as tslib_1 from "tslib";
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import * as React from 'react';
import { getRTL } from 'office-ui-fabric-react/lib/Utilities';
var styles = require('./MailListItemTwistyButton.scss');
var classNames = require('classnames/bind');
var MailListItemTwistyButton = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemTwistyButton, _super);
    function MailListItemTwistyButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailListItemTwistyButton.prototype.render = function () {
        var twistyImageClassNames = classNames(styles.twistyImage, this.props.isExpanded && (getRTL() ? styles.expandedrtl : styles.expandedltr));
        return (React.createElement(IconButton, { className: classNames(this.props.className, styles.button, 'flipForRtl'), iconProps: {
                iconName: "ChevronRightMed" /* ChevronRightMed */,
                styles: {
                    root: twistyImageClassNames,
                },
            }, tabIndex: -1, onClick: this.props.onClick, onDoubleClick: function (evt) {
                evt.stopPropagation();
            } }));
    };
    return MailListItemTwistyButton;
}(React.Component));
export default MailListItemTwistyButton;
//# sourceMappingURL=MailListItemTwistyButton.js.map